import type { ComponentProps } from "react";
import { AdminDataNotice } from "@/components/admin/data-notice";
import { MailboxesView } from "@/components/admin/prospection/mailboxes-view";
import { useView, usePageTitle } from "@shared/client/view";

export default function ProspectionMailboxesPage() {
  usePageTitle("Boîtes d’envoi — Prospection — Administration Hune");
  const { data, error } = useView<ComponentProps<typeof MailboxesView>>("/api/views/admin/prospection/mailboxes");
  if (error) return <AdminDataNotice error={error} />;
  if (!data) return null;
  return <MailboxesView {...data} />;
}
